import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import EventListInfoWindow from './EventListInfoWindow';
import EventMarker from './EventMarker';

class DispatchMap extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state ={
      infoWindowPosition: null,
      showInfoWindow: false
    };

    this.handleClusterClick = this.handleClusterClick.bind(this);
    this.handleInfoWindowClose = this.handleInfoWindowClose.bind(this);
  }

  handleClusterClick(cluster) {
    const markers = cluster.getMarkers();
    const { position } = markers[0];
    if (markers.every(m => m.position.equals(position))) {
      this.setState({
        infoWindowPosition: {
          lat: Math.round(position.lat() * 10000000) / 10000000,
          lng: Math.round(position.lng() * 10000000) / 10000000
        },
        showInfoWindow: true
      });
    }
  }

  handleInfoWindowClose() {
    this.setState({
      infoWindowPosition: null,
      showInfoWindow: false
    });
  }

  render() {
    const { defaultCenter, events, onEventClick, onPreviewEvent } = this.props;
    const { infoWindowPosition, showInfoWindow } = this.state;
    return (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={defaultCenter}
      >
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          onClick={this.handleClusterClick}
        >
          {events.map((e) => (
            <EventMarker
              event={e}
              key={e.id}
              onDblClick={() => onEventClick(e)}
              onMouseOver={() => onPreviewEvent(e)}
              onMouseOut={() => onPreviewEvent(null)}
            />
          ))}
        </MarkerClusterer>
        {showInfoWindow && (
          <EventListInfoWindow
            events={events.filter(e => e.geoPoint.latitude === infoWindowPosition.lat && e.geoPoint.longitude === infoWindowPosition.lng)}
            position={infoWindowPosition}
            onCloseClick={this.handleInfoWindowClose}
            onEventClick={onEventClick}
            onPreviewEvent={onPreviewEvent}
          />
        )}
      </GoogleMap>
    );
  }

}

export default withScriptjs(withGoogleMap(DispatchMap));
